import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-feature',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss']
})
export class FeatureComponent implements OnInit {
  @Input() label: string = '';
  @Input() content: string = '';
  @Input() iconImage: string = '';
  
  constructor() {}

  ngOnInit(): void {}
}
